<template>
    <form @submit.prevent="onSubmit" @reset="onReset" class="d-flex align-items-top row" ref="form">
        <div class="col-md-4 col-sm-8">
            <select class="form-select form-select-sm" multiple v-model="selected" :size="numOptions">
                <option v-for="option in options" :key="option.id" :value="option">
                    {{ option.name }}
                </option>
            </select>
        </div>

        <div class="col-auto">
            <div class="row gap-2">
                <button type="submit" class="btn btn-outline-primary btn-sm" :disabled="!hasSelection">
                    Filtrar
                </button>
                <button type="reset" class="btn btn-outline-danger btn-sm" :disabled="!hasSelection">
                    Limpiar
                </button>
            </div>
        </div>
    </form>
</template>
<script>
import { mapActions } from 'vuex';

export default {
    name: 'RoleFilter',

    data() {
        return {
            selected: [],
            options: []
        }
    },

    computed: {
        numOptions() {
            return this.options.length
        },

        hasSelection() {
            return this.selected.length > 0
        }
    },

    async mounted() {
        let result = await this.allRoles();
        if (result.isError) {
            return;
        }

        this.options = result.data
    },

    methods: {
        ...mapActions(["allRoles"]),

        onSubmit() {
            this.$emit('filter', this.selected);
        },

        onReset() {
            this.selected = [];
            this.$emit('clear');
        },
    },
}
</script>
